module.exports = __webpack_public_path__ + "img/hr-green-small-grass-04.d59af352.png";